import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { holdingStatusesDataSource } from 'infrastructure/data-sources/holding-statuses';
import { useSelectAll } from 'infrastructure/antd/hooks/use-select-all';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { IHoldingStatusItem } from 'infrastructure/data-sources/holding-statuses';

type Options = IBaseSelectBoxOption<
  IHoldingStatusItem['id'],
  IHoldingStatusItem
>[];

interface IHoldingStatusSelectBoxProps
  extends Omit<IBaseSelectBoxProps, 'options'> {
  withEmpty?: boolean;
  withAll?: boolean;
  showSelectAll?: boolean;
}

const HoldingStatusSelectBox: React.FC<IHoldingStatusSelectBoxProps> = (
  props,
) => {
  const { withAll = false, showSelectAll = false, value, onChange } = props;

  const dataSource = useMemo(
    () => holdingStatusesDataSource({ withAll }),
    [withAll],
  );

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  const selectProps = useSelectAll({
    showSelectAll,
    value,
    onChange: onChange as any,
    options,
  });

  return <BaseSelectBox {...props} {...selectProps} />;
};

export default HoldingStatusSelectBox;
